/**
 * Hàng đang về trên đơn bán (anh Tiến 21/10/2026, DEC-402): NV kinh doanh ghi thiếu mã nào, bao nhiêu, ngày dự kiến về, ghi chú.
 * Điều phối, kho, tài xế, Kiểm soát cùng thấy. Chỉ là ghi chú: không đổi số lượng đơn / phiếu giao.
 */
import { formatQty } from './format';

export const ORDER_INCOMING_STATUSES = ['open', 'arrived', 'cancelled'] as const;
export type OrderIncomingStatus = (typeof ORDER_INCOMING_STATUSES)[number];

export const ORDER_INCOMING_STATUS_LABELS: Record<OrderIncomingStatus, string> = {
  open: 'Đang về',
  arrived: 'Đã về',
  cancelled: 'Bỏ ghi chú',
};

/** Một dòng "hàng đang về" (đang mở) hiện trên phiếu giao, Soạn hàng, màn tài xế. */
export interface OrderIncomingLine {
  id: number;
  productCode: string | null;
  productName: string;
  unit: string | null;
  quantity: number | null;
  /** YYYY-MM-DD, null = chưa rõ ngày */
  eta: string | null;
  note: string | null;
  createdByName: string;
  createdAt: string;
}

/** "Hàng đang về 23/10: Thép hộp 40x80 × 20 cây; …" – một dòng gọn cho thẻ phiếu */
export function orderIncomingSummary(rows: readonly OrderIncomingLine[]): string {
  return rows
    .map((r) => {
      const qty = r.quantity !== null ? ` × ${formatQty(r.quantity)}${r.unit ? ` ${r.unit}` : ''}` : '';
      const eta = r.eta ? ` (về ${r.eta.slice(8, 10)}/${r.eta.slice(5, 7)})` : '';
      return `${r.productCode ? `${r.productCode} ` : ''}${r.productName}${qty}${eta}`;
    })
    .join('; ');
}
